import { useState, ReactNode } from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { PowerSchedule } from '@/features/plants/schemas/schedule-plant.schema.ts';

interface DeleteScheduleModalProps {
  children: ReactNode;
  schedule: PowerSchedule;
  onDeleteSchedule: (scheduleId: string) => void;
}

export function DeleteScheduleModal({
  children,
  schedule,
  onDeleteSchedule,
}: DeleteScheduleModalProps) {
  const [open, setOpen] = useState(false);

  const handleDeleteSchedule = () => {
    onDeleteSchedule(schedule.scheduleId);
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Delete Schedule</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete "{schedule.scheduleName}"? This action cannot be
            undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={handleCancel}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={handleDeleteSchedule}>
            Delete Schedule
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
